import { withStyles } from '@material-ui/core/styles';
import DocumentsGrid from './documentsGrid.component';
import NotesGrid from './notesGrid.component';
import React, { Component } from 'react';

const styles = (theme) => ({

});

class DocumentsNotes extends Component {
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  componentWillMount() {

  }

  render() {
    let { authId, documents, comments, busCodes, allEnums } = this.props;
    const stripHtml = (value) => {
      if (!value || typeof value !== 'string') {
        return value;
      }

      return value.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    };

    // documents = documents.map((doc) => {
    //   return {
    //     ...doc,
    //     FileName: doc.ReportDesc + doc.ReportType,
    //   };
    // });

    const safeComments = Array.isArray(comments) ? comments : [];
    const clientViewableComments = safeComments
      .filter((comment) => comment.isClientViewable === true)
      .map((comment) => {
      const serviceId = comment.serviceId;
      const commentText = comment.comment;
      const description = stripHtml(commentText);
      const descriptionPreview = description || '(No description)';
      const hasAttachment = comment.hasAttachment ?? 0;

      return {
        ...comment,
        serviceId,
        addedBy: comment.addedBy ?? comment.fullName ?? comment.addedByUserId ?? '',
        commentText,
        description: descriptionPreview,
        isClientViewable: true,
        hasAttachment,
        categoryId: allEnums?.authCommentService?.find((code) => code.id === serviceId)?.title || '',
      };
    });

    const clientViewableDocuments = Array.isArray(documents) ? documents : [];

    return (
      <div>
        <div style={{ marginBottom: '1rem' }}>
          <DocumentsGrid rows={clientViewableDocuments} />
        </div>
        <div>
          <NotesGrid authId={authId} rows={clientViewableComments} attachments={clientViewableDocuments} busCodes={busCodes} enums={allEnums}/>
        </div>
      </div>
    );
  }
}

DocumentsNotes.propTypes = {

};

DocumentsNotes = withStyles(styles)(DocumentsNotes);

export default DocumentsNotes;